import React from "react";
import { CardContentType, LanguageEnum } from "../../types";
import MockCard from "./MockCard";

interface SmallMockCardProps {
  content: CardContentType | null;
  language: LanguageEnum;
  width?: number; // width in px
}

const SmallMockCard: React.FC<SmallMockCardProps> = ({ content, language, width = 100 }) => {

  const height = (width * 3) / 5;
  const baseWidth = 500; 
  const scale = width / baseWidth;

  return (
    <div style={{ width: `${width}px`, height: `${height}px`, overflow: "hidden" }} className="border border-solid border-gray-400">
      <div
        style={{
          transform: `scale(${scale})`,
          transformOrigin: "top left",
          width: `${baseWidth}px`,
          height: `${(baseWidth * 3) / 5}px`,
        }}
      >
        <MockCard content={content} language={language} />
      </div>
    </div>
  );
};

export default SmallMockCard;